export const MUI_PRIMARY_MAIN = '#1C4220';
export const MUI_SECONDARY_MAIN = '#789d4a';
export const HIGH_EMPHASIS = '#2D343B';
export const MEDIUM_EMPHASIS = '#6A6E73';
export const DISABLED = '#9B9EA1';
export const BASE_FIELD_BACKGROUND_COLOR = 'rgba(255,255,255,0.5)';

export const FIELD_BACKGROUND = '#F1EFED';
export const FIELD_BACKGROUND_DISABLED = 'rgba(241, 239, 237, 0.50)';
export const BASIC_BORDER_RADIUS = '8px';
export const BASIC_BORDER_COLOR = '#E3E0DB';
export const BASIC_GAP = '16px';
export const USER_AVATAR_COLOR = '#1C4220';

export const KPI_CAUTION_BADGE_COLOR = '#FFC83C';
export const KPI_OPTIMAL_BADGE_COLOR = '#5BC840';
export const KPI_CRITICAL_BADGE_COLOR = '#E81B1B';

export const MENU_USER_AVATAR_COLOR = '#CFD3D0';
export const MENU_USER_AVATAR_BACKGROUND_COLOR = '#475648';

export const TABLE_ODD_ROW_BACKGROUND_COLOR = 'rgba(241,239,237, 0.5)';
